import { render, staticRenderFns } from "./Auto.vue?vue&type=template&id=43a0215c&scoped=true&"
import script from "./Auto.vue?vue&type=script&lang=js&"
export * from "./Auto.vue?vue&type=script&lang=js&"
import style0 from "./Auto.vue?vue&type=style&index=0&id=43a0215c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a0215c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a0215c')) {
      api.createRecord('43a0215c', component.options)
    } else {
      api.reload('43a0215c', component.options)
    }
    module.hot.accept("./Auto.vue?vue&type=template&id=43a0215c&scoped=true&", function () {
      api.rerender('43a0215c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Auto.vue"
export default component.exports